<template>
  <b-overlay
    :show="loading"
    rounded="sm"
  >
    <b-row>
      <b-col>
        <b-card>
          <b-card-title>
            <span>جزئیات اطلاعات کاربر</span>
            <b-button
              v-ripple.400="'rgba(186, 191, 199, 0.15)'"
              variant="outline-secondary"
              class="float-right"
              @click="back"
            >
              بازگشت
            </b-button>
          </b-card-title>
          <b-row>
            <b-col
              md="10"
              class="offset-xl-1"
            >
              <b-tabs card>
                <b-tab
                  title="پروفایل"
                >
                  <UserViewUserInfoCard
                    :user-id="userId"
                    :user-data="userData"
                    ref="User"
                    @loading="loading=$event"
                  />
                </b-tab>
                <b-tab
                  title="اطلاعات جسمانی"
                >
                  <UserPhysicalInfo :user-id="$route.params.id" />
                </b-tab>
                <b-tab
                  title="سفارش های رژیم"
                  :disabled="!$can('show', 'OrderView')"
                >
                  <userOrders :user-id="userId"
                              ref="UserDietOrder"
                              @UserDietTerms="$refs.UserDietTerms.dietOrders()"
                              @ActivityPackageOrder="$refs.ActivityPackageOrder.get()"
                  />
                </b-tab>

                <b-tab
                    title="ترم های رژیم"
                >
                  <UserDietTerms :user-id="userId" ref="UserDietTerms" />
                </b-tab>

                <b-tab
                    title="سفارش های ورزش"
                    :disabled="!$can('show', 'OrderView')"
                >
                  <activity-package-order :user-id="userId" ref="ActivityPackageOrder"
                                          @UserDietTerms="$refs.UserDietTerms.dietOrders()"
                                          @UserDietOrder="$refs.UserDietOrder.dietOrders()"
                  />
                </b-tab>

              <b-tab title="پرسش و پاسخ">

                <user-question-answer :userId="userId" @User="$refs.User.getUserInfo()"  />

              </b-tab>

                <b-tab
                  title="برنامه غذایی"
                >
                  <dataPickerStep v-model="dietInDate" />
                  <foodSchedule
                    :diet-in-date="dietInDate"
                    :user-id="userId"
                  />
                </b-tab>

                <b-tab
                    title="توکن ها"
                >
                  <user-token
                      :user-id="userId"
                  />
                </b-tab>

                <b-tab
                    v-if="$can('show', 'HeroManagment')"
                    title="رکوردداران"
                >
                  <user-hero
                      :user-id="userId"
                      :is-hero="isHero"
                      @updateUser="getUserInfo"
                  />
                </b-tab>

<!--                <b-tab-->
<!--                  title="پیام ها"-->
<!--                >-->
<!--                  <template #title>-->
<!--                    <feather-icon icon="message" />-->
<!--                    <span class="d-none d-sm-inline">پیام ها</span>-->
<!--                  </template>-->
<!--                  <MessageInbox :user-id="userId"-->
<!--                  />-->
<!--                </b-tab>-->
<!--                -->
<!--                <b-tab-->
<!--                  title="موفقیت"-->
<!--                  :disabled="true"-->
<!--                >-->
<!--                  <template #title>-->
<!--                    <feather-icon icon="AwardIcon" />-->
<!--                    <span class="d-none d-sm-inline">موفقیت</span>-->
<!--                  </template>-->
<!--                  <userSuccess />-->
<!--                </b-tab>-->

              </b-tabs>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </b-overlay>
</template>
<script>
import { BIcon, BIconCartPlus, BIconSun } from 'bootstrap-vue'
import UserViewUserInfoCard from '@/views/menu/user/UserViewUserInfoCard.vue'
import UserPhysicalInfo from '@/views/menu/user/userPhysicalInfo.vue'
import UserDietTerms from '@/views/menu/user/userDietTerms.vue'
import UserSportTerms from '@/views/menu/user/userSportTerms.vue'
import foodSchedule from '@/views/menu/user/foodSchedule.vue'
import dataPickerStep from '@/tools/datePickerStep.vue'
import userSuccess from '@/views/menu/user/userSuccess.vue'
import userOrders from '@/views/menu/user/userOrders.vue'
import ActivityPackageOrder from '@/views/menu/user/activitypackageorder.vue'
import MessageInbox from '@/views/menu/notification/messageInbox.vue'
import UserQuestionAnswer from '@/views/menu/user/UserQuestionAnswer.vue'
import UserToken from '@/views/menu/user/userToken.vue'
import UserHero from "@/views/menu/user/userHero.vue";

export default {
  name: 'UserDetails',
  components: {
    BIcon,
    BIconCartPlus,
    BIconSun,
    UserViewUserInfoCard,
    UserPhysicalInfo,
    UserDietTerms,
    UserSportTerms,
    foodSchedule,
    dataPickerStep,
    userSuccess,
    userOrders,
    ActivityPackageOrder,
    MessageInbox,
    UserQuestionAnswer,
    UserToken,
    UserHero,
  },
  data() {
    return {
      loading: false,
      userData: {},
      dietInDate: null,
      userId: this.$route.params.id,
    }
  },
  computed: {
    isHero() {
      return this.userData.IsHero
    }
  },
  created() {
    this.getUserInfo()
    this.dietInDate = this.$moment().format('YYYY-MM-DD')
  },
  methods: {
    getUserInfo() {
      this.loading = true
      this.$http.post(this.$api.user.get, { Id: this.$route.params.id }).then(res => {
        this.userData = res.data
        this.loading = false
      })
    },
  }
}
</script>
